<template>
  <div class="bookBuy">
    <div class="container">
      <!-- 订单信息开始 -->
      <div class="box">
        <div class="box_item">
          <div class="left">
            <van-image class="img" :src="detail.cover"></van-image>
            <div class="num" v-if="type === 0">{{ detail.learnCount }}人已学</div>
          </div>
          <div class="right">
            <div class="top">
              <div class="title">{{ detail.name }}</div>
              <div class="text" v-if="type === 0">共{{ detail.chapterCount }}章{{ detail.annexCount }}节</div>
            </div>
            <div class="bottomPrice">￥{{ detail.price | toFixed }}</div>
          </div>
        </div>
      </div>
      <!-- 订单信息结束 -->

      <div class="content">
        <!-- 支付方式开始 -->
        <div class="section section_01">
          <div class="section_title">支付方式</div>
          <div class="section_content">
            <ul class="list">
              <!-- 微信、支付宝 -->
              <li class="list_item"
                v-for="(item, index) in payMent.payMethods"
                :key="index"
                :class="{active:item.payType === payMent.payType}"
                @click="payChange(item)"
              >
                <van-image class="img" :src="item.img" fit="cover"></van-image>
                <div class="text">{{ item.text }}</div>
                <i class="active_icon"></i>
              </li>
            </ul>
            <template v-if="payMent.payType===3">
              <Field v-model="text" placeholder="请输入激活码"></Field>
            </template>
          </div>
        </div>
        <!-- 支付方式结束 -->

        <!-- 积分抵用开始 -->
        <div class="section section_02" v-if="payMent.payType !== 3">
          <div class="title">
            <div class="section_title">
              <div>使用积分抵用</div>
            </div>
            <van-switch v-model="checked" size="20px" active-color="#2E86FF"/>
          </div>

          <div class="section_content" v-if="checked">

            <div class="van-cell van-field">
              <div class="van-cell__value van-cell__value--alone van-field__value">
                <div class="van-field__body">
                  <input type="tel" v-model="integralText" placeholder="请输入抵扣积分数" class="van-field__control">
                </div>
              </div>
            </div>

            <!-- <input class="input "  placeholder="请输入抵扣积分数" type="tel" /> -->
            <div class="list">
              <div class="list_item jsb">
                <div class="left">
                  <van-image class="img" :src="require('@/assets/images/book/icon_pay_04.png')" fit="cover"></van-image>
                  <div class="text">当前积分余额 <span class="exera">{{ detail.integral }}</span></div>
                  <i class="active_icon"></i>
                </div>
                <div class="all" @click="integralText = detail.integral">全部抵扣</div>
              </div>
            </div>


            <!-- <ul class="list">
              <li class="list_item"
                :class="{active:pointPayment}"
                @click="pointPayment = !pointPayment"
              >
                <van-image class="img" :src="require('@/assets/images/book/icon_pay_04.png')" fit="cover"></van-image>
                <div class="text">当前积分余额 <span class="exera">20</span></div>
                <i class="active_icon"></i>
              </li>
            </ul> -->
          </div>
        </div>
        <!-- 积分抵用结束 -->
      </div>


      <div class="bottom">
        <div class="price">应付：<span class="big">￥{{ (payPrice - savePrice) | toFixed }}</span></div>
        <p class="text">注意：请在30分钟内完成支付，否则订单会被自动取消</p>
        <div class="btn" @click="pay" v-if="payMent.payType !== 3">确认支付</div>
        <div class="btn" @click="pay" v-else>兑换</div>
        <div class="agreement">
          <Checkbox v-model="agreementCheck"  checked-color="#1989fa" shape="square" icon-size="14px"/>
          <div class="text">我已阅读并同意
            <span class="link" @click.prevent.stop="$router.push({name:'HelpCenter',params:{type:3}})">《用户服务协议》</span>
            <!-- <span class="link" @click.prevent.stop="$router.push({name:'HelpCenter',params:{type:5}})">《广东教育出版社知识产权保护协议》</span></div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="iphoneX"></div>
  </div>
</template>

<script>
import { Field, Switch, Checkbox } from 'vant';
export default {
  components: {
    'van-switch': Switch,
    Checkbox,
    Field
  },
  data () {
    return {
      id: 0, // 购买对象ID
      active: 1, // 1(粤教培训)，2（优秀课例）,3（资源）
      type: 0, // 0(课程)，1(章节)，2(资源附件)，3(练习题测试题)
      detail: {}, // 订单详情信息
      checked: false, // 是否使用积分
      agreementCheck: false, // 勾选协议
      // 支付方式
      payMent: {
        payType: 2, // 2：微信  1：支付宝
        payMethods: [
          { img: require('@/assets/images/book/icon_pay_01.png'), text: '微信', payType: 2 },
          { img: require('@/assets/images/book/icon_pay_03.png'), text: '使用激活码兑换', payType: 3 }
        ]
      },
      payPrice: 0, // 最终价格
      integralText: '', // 积分
      savePrice: 0, // 积分抵扣价格

      pointPayment: false, // 积分支付
      text: '',

      getWay: {
        1: 'course/buy', // 粤教培训
        2: 'lesson/buy', // 优秀案例
        3: 'resource/curriculumOrder' // 教学资源
      },

      payWay: {
        1: 'course/h5/order', // 粤教培训
        2: 'lesson/h5/order', // 优秀案例
        3: 'resource/h5/orderRelease' // 教学资源
      },
      allInfo: {} // 支付信息

    };
  },
  computed: {

    // /* 最终支付的价格 */
    payPrcie () {
      let { checked, detail, integralText } = this;
      let total = 0;

      /* 如果开启积分抵换且有输入值时 */
      if (checked && integralText) {
        return 0;
      }

      /* 如果没有开始积分抵换时 */
      total = detail.payPrice;

      return total;
    }
  },
  watch: {

    /* 积分变化 价格相应变化 */
    integralText (newValue) {
      const { detail } = this;
      const { integral } = detail;
      if (newValue * 1 <= integral) {
        newValue ? this.integralPrice() : this.savePrice = 0;
      } else {
        this.integralText = integral;
      }
    }
  },

  mounted () {
    const { $route: { query } } = this;
    this.id = query.id; // 获取id
    this.type = query.type * 1; // 获取支付的类型
    this.active = query.active * 1 + 1; // 获取课程的归类
    /* 如果不是全部购买，则将激活码支付选项清除 */
    if (this.type !== 0 && this.type !== 4) {
      console.log(this.type, typeof this.type);
      this.payMent.payMethods.pop();
    }
    this.getDetail();
  },
  methods: {

    /* 获取详情 */
    getDetail () {
      const { $http, id, $utils, $router, type, active, getWay } = this;
      if (id) {
        $http.get(`${getWay[active]}`, {
          params: {
            id,
            type
          },
          showLoading: true,
          loadingText: '生成订单信息中...'
        }).then((res) => {
          this.detail = res.data || {};
          this.payPrice = this.detail.payPrice;
        });
      } else {
        $utils.failToast({
          message: '信息为空',
          onClose: () => {
            $router.go(-1);
          }
        });
      }
    },

    /* 切换支付方式 */
    payChange (item) {
      this.payMent.payType = item.payType;
    },

    /* 积分抵用 */
    integralPrice () {
      const { $http, $utils, integralText, detail } = this;
      $http.get('order/userIntegral', {
        params: {
          integral: integralText,
          payMoney: detail.payPrice
        },
        customError: true
      }).then((res) => {
        this.savePrice = res.data.money;
      }).catch(({ data }) => {
        $utils.toast({
          message: data.msg,
          duration: 2000,
          onClose: () => {
            this.integralText = '';
          }
        });
      });
    },

    /* 支付 */
    pay () {
      const { $http, $utils, agreementCheck, type, id, payMent: { payType }, integralText, payWay, active, text } = this;
      if (!agreementCheck) {
        $utils.toast('请勾选《用户服务协议》');
        return false;
      }

      this.allInfo = { id: id * 1, integral: integralText, payType, type, activationCode: text };
      if (payType === 2) {
        if (!/MicroMessenger/.test(window.navigator.userAgent)) {
          $utils.toast('请前往微信客户端进行支付');
          return false;
        }
        $http.post(`${payWay[active]}`, this.allInfo).then((res) => {
          const data = res.data || {};

          this.setWeiPay(data, (res) => {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              this.isPay(data.orderId); // 轮询
            }
          });
        });
      } else {
        $http.post(`${payWay[active]}`, this.allInfo).then((res) => {
          if (res.result === 1) {
            this.success();
          }
        });
      }

    },

    setWeiPay (data, callback) {
      if (typeof window.WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', this.weiPay(data, callback), false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', this.weiPay(data, callback));
          document.attachEvent('onWeixinJSBridgeReady', this.weiPay(data, callback));
        }
      } else {
        this.weiPay(data, callback);
      }
    },

    /* 唤起微信支付 */
    weiPay (data, callback) {
      console.log(data);
      window.WeixinJSBridge.invoke(
        'getBrandWCPayRequest', {
          'appId': data.appId, // 公众号名称，由商户传入
          'timeStamp': data.timeStamp, // 时间戳，自1970年以来的秒数
          'nonceStr': data.nonceStr, // 随机串
          'package': data.package,
          'signType': data.signType, // 微信签名方式：
          'paySign': data.paySign // 微信签名
        }, (res) => {
          callback && callback(res);
        }
      );
    },

    /* 循环调用支付 */
    isPay (id) {
      clearTimeout(this.timer);
      this.timer = setTimeout(async () => {
        const res = await this.$http.get('order/isPay', {
          params: {
            id
          },
          customError: true,
          showLoading: true
        });
        if (res.result === 1 && res.data.payStatus === 1) {
          this.success();
        } else {
          this.isPay(id);
        }
      }, 1000);
    },

    /* 支付成功 */
    success () {
      const { payMent: { payType }, active } = this;
      let payBoolean; // true 激活码兑换  false 支付购买
      switch (payType) {
        case 2:
          payBoolean = false;
          break;
        case 3:
          payBoolean = true;
          break;
      }

      console.log(payType, payBoolean);
      this.$router.push({
        name: 'BookBuyResult',
        query: {
          active,
          isPay: payBoolean
        }
      });
    }


  }
};
</script>

<style scoped lang="less">
  .bookBuy{
    padding:10px 28px;
    height: 100%;
    .container{
      display: flex;
      flex-direction: column;
      height: 100%;
      .box{
        padding:12px 0px 0;
        width: 100%;
        .box_item{
          display: flex;
          justify-content: space-between;
          border-bottom: 20px solid #F9FAFC;
          padding-bottom: 40px;
          .left{
            margin-right: 28px;
            position: relative;
            .img{
              width: 216px;
              height: 144px;
            }
            .num{
              position: absolute;
              right: 0;
              bottom: 0;
              background: rgba(0,0,0,.5);
              border-radius: 8px 0px 8px 0px;
              display: flex;
              align-items: center;
              font-size: 20px;
              padding: 6px 12px;
              color: #fff;
            }
          }
          .right{
            font-size: 24px;
            color: #999AAA;
            display: flex;
            flex-direction: column;
            width: 466px;
            justify-content: space-between;
            .top{
              .title{
                font-size: 28px;
                font-weight: bold;
                color: #333444;
                margin-bottom: 20px;
              }
              .text{
                font-size: 24px;
                color: #999AAA;
                .text-overflow();
              }
            }
            .bottomPrice{
              color: #FC485D;
              font-size: 28px;
              font-weight: bold;
            }
          }
        }
      }
      .content{
        flex: 1;
        padding-bottom: 10px;
        height: 400px;
        /*overflow-y: scroll;*/
        /*overflow-x: hidden;*/
        .section{
          padding: 40px 0 0;
          .section_title{
            font-size: 32px;
            font-weight: bold;
            color: #333444;
            display: flex;
            align-items: center;
            margin-bottom: 40px;
            &::before{
              content: "";
              display: inline-block;
              width: 8px;
              height: 32px;
              background: #5FA9FF;
              border-radius: 4px;
              margin-right: 20px;
            }
          }
          .title{
            display: flex;
            justify-content: space-between;
          }

          .section_content{
            .list{
              display: flex;
              flex-direction: column;
              .list_item{
                width: 100%;
                height: 124px;
                background: #FFFFFF;
                border-radius: 10px;
                border-bottom: 1px solid #F0F0F0;
                display: flex;
                align-items: center;
                padding: 0 18px;
                position: relative;
                &.jsb{
                  justify-content: space-between;
                  .left{
                    display: flex;
                    align-items: center;
                    .img{
                      margin-right: 8px;
                    }
                    .text{
                      .exera{
                        font-size: 30px;
                        font-weight: bold;
                        color: #333333;
                      }
                    }
                  }
                }
                .img{
                  width: 36px;
                  height: 36px;
                  display: inline-block;
                  margin-right: 16px;
                }
                &.active{
                  border: 2px solid #5FA9FF;
                  .active_icon{
                    display: inline-block;
                    width: 40px;
                    height: 28px;
                    position: absolute;
                    right: -3px;
                    bottom: -1px;
                    background-image: url('~@/assets/images/book/icon_check_01.png');
                    background-size: contain;
                  }
                }
                .text{
                  font-size: 26px;
                  line-height: 48px;
                  color: #333333;
                  background-size: contain;
                  background-repeat: no-repeat;
                }
                .all{
                  font-size: 26px;
                  color: #5FA9FF;
                }
              }
            }
            /deep/.van-cell{
              margin-top: 20px;
              background-color: #F6F6F6;
              .van-field__label{
                display: none;
              }
            }
          }
          &.section_02{
            margin-bottom: 40px;
            .section_content{
              .input{
                width: 100%;
                height: 84px;
                background: #F6F6F6;
                border-radius: 10px;
                border:none;
                font-size: 26px;
                line-height: 0px;
                color: #C1C1C1;
                padding-left: 20px;
              }
              .list_item{
                .text{
                  .exera{
                    font-size: 30px;
                    font-weight: bold;
                    color: #5FA9FF;
                    margin-left: 20px;
                  }
                }
              }
            }
          }
        }
      }
      .bottom{
        background: #fff;
        padding: 18px 28px 8px;
        .price{
          font-size: 36px;
          color: #333333;
          text-align: right;
          margin-bottom: 68px;
          .big{
            font-weight: bold;
            color: #FF485D;
          }
        }
        .text{
          text-align: center;
          font-size: 22px;
          line-height: 32px;
          color: #999999;
          margin-bottom: 70px;
        }
        .btn{
          width: 450px;
          height: 76px;
          background: linear-gradient(90deg, #2E86FF 0%, #5FA9FF 100%);
          box-shadow: 0px 6px 40px rgba(95, 169, 255, 0.3);
          border-radius: 44px;
          font-size: 28px;
          line-height: 76px;
          color: #FFFFFF;
          margin: 0 auto;
          text-align: center;
          margin-bottom: 40px;
        }
        .agreement{
          display: flex;
          align-items: flex-start;
          justify-content: center;
          /deep/.van-checkbox{
            padding: 4px;
            flex-shrink: 0;
            border-radius: 8px;
            .van-icon{
              color: #fff;
            }
          }
          .text{
            text-align: left;
            margin-bottom: 0;
            margin-left: 12px;
            font-size: 22px;
            color: #999999;
            .link{
              color: #5FA9FF;
            }
          }
        }
      }
    }

  }
</style>
